import React from 'react';

const Trophy = () => {
  return (
    <div className="trophy">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="144"
        height="110"
        viewBox="0 0 144 110"
      >
        <g fill="none" fillRule="evenodd" stroke="#FF7D55" strokeWidth="4">
          <path d="M42.282 56.564C37.44 53.687 32.196 50.81 31.86 42.25c-.134-3.345 0-11.371 0-11.371v-7.157s-.134-.937.605-1.806c.74-.87 1.614-.736 1.614-.736h6.724v-7.692H29.44c-2.959 0-5.312 2.341-5.312 5.284v23.879c0 11.973 9.75 21.738 21.852 21.738M100.173 7.268H42.887a2.16 2.16 0 0 0-2.152 2.14v2.609c0 1.204 1.009 2.14 2.152 2.14h57.286a2.16 2.16 0 0 0 2.152-2.14v-2.61c0-1.203-.941-2.14-2.152-2.14zM100.779 56.564c4.84-2.877 10.085-5.753 10.421-14.314.135-3.345 0-11.371 0-11.371v-7.157s.135-.937-.605-1.806c-.74-.87-1.613-.736-1.613-.736h-6.724v-7.692h11.363c2.958 0 5.312 2.341 5.312 5.284v23.879c0 11.973-9.75 21.738-21.852 21.738" />
          <path d="M71.463 79.707c-.47-.067-.874-.067-1.277-.134-16.54-1.806-29.383-15.719-29.383-32.708V14.023H102.325v32.909c0 16.922-12.842 30.835-29.383 32.708-.403.067-.807.067-1.21.134h-.067c-.068-.067-.135-.067-.202-.067zM67.63 91.88V79.64M75.43 79.506v12.709" />
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M71.53 91.345c-9.077 0-16.406 7.29-16.406 16.254H87.87c0-8.963-7.329-16.254-16.339-16.254z"
          />
          <g strokeLinecap="round" strokeLinejoin="round">
            <path d="M132.238 40.507h9.524M136.761 35.555v9.434M2.476 45.46H12M7 40.507v9.434M8.34 3.333l7.296 6.122M14.989 2.447L8.925 9.674M113.579 71.254l7.295 6.122M120.227 70.368l-6.064 7.227M114.857 3.481v4.717M124.052 6.934l-3.06 3.613M127.953 17.867h-4.762" />
          </g>
        </g>
      </svg>
    </div>
  );
};

export default Trophy;
